import {FmlxButton} from 'fmlx-common-ui';
import {useDispatch, useSelector} from 'react-redux';

import {hideModal} from '@/actions/modalStateAction';
import ModalCommonButtons from '@/components/modal/ModalCommonButtons';
import ModalCommonContent from '@/components/modal/ModalCommonContent';
import ModalCommonFooter from '@/components/modal/ModalCommonFooter';
import ModalCommonHeader from '@/components/modal/ModalCommonHeader';
import useIntlFormat from '@/hooks/useIntlFormat';
import {getContent} from '@/selectors/modalSelector';

function ModalGenericErrorHeader() {
  const {formatMessage} = useIntlFormat();

  const title = formatMessage({id: 'modal.genericError.title'});

  return <ModalCommonHeader title={title} />;
}

function ModalGenericErrorFooter() {
  const {formatMessage} = useIntlFormat();
  const dispatch = useDispatch();

  const buttons = [
    {
      id: 'modal-genericError-primaryButton',
      show: true,
      label: formatMessage({id: 'modal.genericError.primaryButton'}),
      type: FmlxButton.Type.PRIMARY,
      variant: FmlxButton.Variant.CONTAIN,
      onClick: () => {
        dispatch(hideModal());
      },
    },
  ];

  return (
    <ModalCommonFooter>
      <ModalCommonButtons data={buttons} />
    </ModalCommonFooter>
  );
}

function ModalGenericErrorContent() {
  const content = useSelector(getContent);

  return <ModalCommonContent>{content}</ModalCommonContent>;
}

const ModalGenericError = {
  Header: ModalGenericErrorHeader,
  Footer: ModalGenericErrorFooter,
  Content: ModalGenericErrorContent,
};

export default ModalGenericError;
